module.exports = __webpack_public_path__ + "assets/img/preview_03.833bc4f3.png";